import { FC } from "react"
import {
  ApiProductState,
  SimCardAddressInput,
  SimCardType2,
} from "@phonero/common-graphql/types"
import { SimCardClassification, useSteps } from "@phonero/common-ux"
import { PuxDialogTitle, PuxText } from "@phonero/pux-react"
import { Data } from "../SimCardWizard/SimCardWizard"
import { SelectSimCardTypeStep } from "./SelectSimCardTypeStep"
import { AddressStep } from "../SimCardWizard/AddressStep"
import { ConfirmStep } from "../SimCardWizard/ConfirmStep"
import {
  SimCardFragment,
  SimCardOrderFragment,
  SimCardProductFragment,
} from "@phonero/common-ux"

export interface IOrderSimCardWizardProps {
  subscriptionId: string
  enableSimWithoutPin: boolean
  address: SimCardAddressInput
  onClose?: () => void
  userName?: string
  msisdn?: string
  availableCards?: (    
    SimCardProductFragment    
  )[]
}

export const OrderSimCardWizard: FC<IOrderSimCardWizardProps> = ({
  subscriptionId,
  enableSimWithoutPin,
  address,
  onClose,
  userName,
  msisdn,
  availableCards,
}) => {
  const [data, setData] = useState<Data>({
    address,
    subscriptionId,
    cardType: SimCardType2.Datacard,
  })

  const [deliveryMethod, setDeliveryMethod] = useState<number | undefined>(0)
  const [simWithoutPin, setSimWithoutPin] = useState<boolean>(false)
  // const [otherAddress, setOtherAddress] = useState<
  //   SimCardAddressInput | undefined
  // >(undefined)
  const { t } = useTranslation()
  const { step, onNext, onPrev } = useSteps({ maxSteps: 3 })
  const [simCardType, setSimCardType] = useState<SimCardType2>()
  const [simCardClassification, setSimCardClassification] = useState<
    SimCardClassification | undefined
  >(SimCardClassification.Nano)
  const [embeddedSimEmail, setEmbeddedSimEmail] = useState<string | undefined>()

  // There can be multiple ie. Datasim cards if privateDataSim and DataSim is available. 
  // The user must select payment method later. 
  const [cards, setCards] = useState<
    (SimCardProductFragment | SimCardFragment | SimCardOrderFragment)[]
  >()
  // const [cardType, setCardType] = useState<SimCardProductFragment | undefined>()

  const handleCardTypeChange = (simType: SimCardType2) => {
    const selectedAvailableCards = availableCards?.filter((c) => {
      const cardType = c as SimCardProductFragment
      return (
        cardType.type === simType       
      )
    }).map(p => p as SimCardProductFragment)
    if (selectedAvailableCards) {
      setCards(selectedAvailableCards)
      setSimCardType(simType)
      setData((d) => ({ ...d, cardType: simType }))
    }
  }

  return (
    <>
      <PuxDialogTitle onBackClick={onPrev} withBackButton={step > 0}>
        <PuxText style={{ fontSize: "2.6rem", fontWeight: 900 }}>
          {"Bestill"}{" "}
          {t("SimCard.Type", { context: step > 0 ? simCardType : undefined })}
        </PuxText>
      </PuxDialogTitle>
      {step === 0 && (
        <SelectSimCardTypeStep
          availableCards={availableCards}
          onNext={onNext}
          simCardType={simCardType}
          setSimCardType={handleCardTypeChange}
        />
      )}
      {step === 1 && (
        <AddressStep
          onNext={onNext}
          address={address}
          data={data}
          setData={setData}          
          enableSimWithoutPin={enableSimWithoutPin}
          simWithoutPin={simWithoutPin}
          setSimWithoutPin={setSimWithoutPin}
          deliveryMethod={deliveryMethod}
          setDeliveryMethod={setDeliveryMethod}
          simCardClassification={simCardClassification}
          setSimCardClassification={setSimCardClassification}
          embeddedSimEmail={embeddedSimEmail}
          setEmbeddedSimEmail={setEmbeddedSimEmail}
        />
      )}
      {step === 2 && (
        <ConfirmStep
          data={data}
          onNext={onNext}
          subscriptionId={subscriptionId}
          address={address}
          sendSimcard={deliveryMethod !== 1}
          cards={cards}
          simWithoutPin={simWithoutPin}
          onClose={onClose}
          userName={userName}
          msisdn={msisdn}
          embeddedSim={simCardClassification === SimCardClassification.Embedded}
          embeddedSimEmail={embeddedSimEmail}
        />
      )}
    </>
  )
}
